export default "__VITE_ASSET__C7Z$PeFi__"